export const state = () => (require('@pleinair/bigcolony-vue/store/jobs/_state')())
export const mutations = require('@pleinair/bigcolony-vue/store/jobs/_mutations')